<template>
  <div class="home container">
    <div class="home-text">
      <h1 class="title">Hola, mi nombre es <span class="title-span">Amilcar Coronado</span></h1>
      <h2 class="home-text__h2">Soy,
        <span class="home-text__random">{{typeValue}}</span>
        <span class="typed-cursor" :class="{'typing': typeStatus}" aria-hidden="true">&nbsp;</span>
        </h2>

        <p class="home-about__summary">
          Soy un profesional responsable y comprometido. Me gusta tomar en cuenta cada detalle a la hora de realizar cualquier proyecto, más preciso sea el desarrollo mejor cumple su objetivo. Aprender y mejorar...
         </p>

         <router-link :to="{ name: 'Sobre' }" class="read-more"
                >Leer Más</router-link
              >
    </div>
    <div class="container-home-image">
      <div class="border-image">
        <img class="home-image" src="../../assets/img/foto-personal.webp" alt="">

      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'HomeView',
  data(){
    return{
      typeValue: '',
      typeStatus: false,
      typeArray: ['Ing. En Sistemas', 'Maquetador Web', 'Programador Web'],
      typingSpeed: 120,
      erasingSpeed: 100,
      newTextDelay: 1000,
      typeArrayIndex: 0 ,
      charIndex: 0
    }
  },
  created(){
    setTimeout(this.typeText, this.newTextDelay + 200)
  },
  methods:{
    typeText(){
      if(this.charIndex < this.typeArray[this.typeArrayIndex].length){
        if(!this.typeStatus)
          this.typeStatus = true;
          this.typeValue += this.typeArray[this.typeArrayIndex].charAt(this.charIndex);
          this.charIndex += 1;
          setTimeout(this.typeText, this.typingSpeed)
        
      }else{
        this.typeStatus = false;
        setTimeout(this.eraseText, this.newTextDelay)
      }
    },
    eraseText(){
      if(this.charIndex > 0){
        if(!this.typeStatus)
        this.typeStatus = true;
        this.typeValue = this.typeArray[this.typeArrayIndex].substring(0, this.charIndex - 1);
        this.charIndex -= 1;
        setTimeout(this.eraseText, this.erasingSpeed);
      }else{
        this.typeStatus = false;
        this.typeArrayIndex += 1;
        if(this.typeArrayIndex >= this.typeArray.length)
        this.typeArrayIndex = 0;
        setTimeout(this.typeText, this.typingSpeed + 1000);
      }
    }
  }
}
</script>
